/** ODP v2 color tokens — light theme palette */

export const colorsLight = {
  background: {
    page: '#F4F4F4',
    default: '#F5F5F5',
    paper: '#FFFFFF',
    sidebar: '#FFFFFF',
    elevated: '#F0F0F0',
  },
  primary: {
    main: '#0078D6',
    hover: '#006CBD',
    gradient: { from: '#0078D6', to: '#16E1CB' },
  },
  text: {
    primary: '#1A1A1A',
    secondary: 'rgba(0, 0, 0, 0.55)',
    link: '#0066BB',
  },
  border: {
    default: '#E0E0E0',
    secondary: '#00000080',
    subtle: '#00000014',
  },
  danger: {
    default: '#FF6B6B',
    hover: '#FF4444',
  },
  star: '#FACC00',
  decorative: {
    netStroke: '#B0B0B0',
  },
  status: {
    healthy: '#198025',
    degraded: '#E5A100',
    critical: '#D92121',
    unknown: '#BDBDBD',
  },
  chart: {
    green: '#198025',
    black: '#333333',
    red: '#D92121',
    yellow: '#E5A100',
  },
  sidebar: {
    active: 'rgba(0, 0, 0, 0.06)',
    hover: 'rgba(0, 0, 0, 0.04)',
    activeText: '#1A1A1A',
    inactiveText: 'rgba(0, 0, 0, 0.55)',
    hoverText: 'rgba(0, 0, 0, 0.8)',
    activeIndicator: '#0078D6',
    aside: '#FFFFFF',
  },
  tags: {
    background: '#EBEBEB',
    emphasisBackground: '#8E8E8E',
    disabled: '#AFAFAF',
  },
  cards: {
    background: '#FFFFFF',
    disabled: '#C0C0C0',
  },
  icon: {
    disabled: '#9A9A9A',
  },
} as const;
